import { Link } from "react-router-dom";
import type { Analysis } from "@/mocks/analyses";
import AnalysisCard from "@/components/base/AnalysisCard";
import SectionHeader from "@/components/base/SectionHeader";

interface AnalysisSectionProps {
  analyses: Analysis[];
}

export default function AnalysisSection({ analyses }: AnalysisSectionProps) {
  return (
    <section className="w-full px-4 md:px-8 py-10 md:py-14 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto">
        <SectionHeader
          title="赛事解析专题"
          subtitle="战术拆解、赛前前瞻与深度复盘，读懂球场上的每一处细节"
          moreTo="/analysis"
          moreLabel="进入专题"
          icon={<i className="ri-article-line text-lg" />}
        />

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
          {analyses.map((a) => (
            <AnalysisCard key={a.id} analysis={a} />
          ))}
        </div>

        <div className="mt-6 md:mt-8 rounded-lg border border-primary-200 bg-primary-50 p-5 md:p-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div>
            <h3 className="text-base md:text-lg font-semibold text-primary-900">
              想更懂球？订阅每日赛事解析
            </h3>
            <p className="text-xs md:text-sm text-primary-800/70 mt-1">
              每天精选战术分析与赛前前瞻，助你从球迷进阶为懂球帝。
            </p>
          </div>
          <Link
            to="/analysis"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 hover:bg-primary-600 text-white text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
          >
            浏览全部解析
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}